import axios from 'axios'
import {Toast} from 'mint-ui'

var querystring = require('querystring');

/* ajax请求 */
var ajax = function(that, url, params, success, method,form) {
  var token = getMessage('token');
  // var openId = sessionStorage.getItem('openId');
  // var params = params || { open_id: openId };
  var headParam;
  if(form){
    headParam={
      // Authorization: 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data',
    };
  }
  else{
    headParam={
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/x-www-form-urlencoded;',
    };
  }
  if (method == 'GET') {
    that.axios({
      method: 'get',
      url: url,
      headers:headParam,
      params: params,
    }).then((response) => {
      if(response.data.code==-2){
        /*主要针对app.vue里的银行弹框的显示隐藏*/
        if(that.popupVisible2==true){
          that.popupVisible2=false;
        }
        that.Toast('请登录');
        that.$router.push({path:"/login"});
      }
      else{
        success(response.data);
        // if(response.data.code!=200){
        //   that.Toast(response.data.message);
        // }
      }
    }).catch(function(response) {
      console.log(response);
      // alert(response.message);
    })
  } else {
    var params = querystring.stringify(params);
    that.axios({
      method: "POST",
      url: url,
      headers:headParam,
      data: params,
    }).then((response) => {
      if(response.data.code==-2){
        that.Toast('请登录');
        that.$router.push({path:"/login"});
      }
      else{
        success(response.data);
      }
    }).catch(function(response) {
      console.log(response);
      // alert(response.message);
    })
  }
}

var getMessage=(key)=>{
  let val=localStorage.getItem(key);
  return val;
};

var setMessage=(key,val)=>{
  localStorage.setItem(key,val);
};

var goback=function(){
  window.history.back();
}

export {
  getMessage,
  setMessage,
  ajax,
  goback,
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js